export const /** @type {?} */ NG_POP_ALERT_CONF = {
  duration: 10000,
};
